import { component } from 'picoapp'
import { zelektor, loopify } from '@/lib/utility-functions.js'

export default component((node, ctx) => {
    /*******************************************************************************************************************************************/
    /* Data + Elements
    /*******************************************************************************************************************************************/
    const { toggle: toggles, list: lists, inner: inners, link: links } = zelektor(node)
    const { gender } = node.dataset
    
    init()


    /*******************************************************************************************************************************************/
    /* Event Listeners
    /*******************************************************************************************************************************************/
    loopify(toggles).forEach(t => {
        t.addEventListener('click', e => {
            const thisToggle = e.currentTarget
            clickToggle(thisToggle)
        })
    })


    /*******************************************************************************************************************************************/
    /* Functions
    /*******************************************************************************************************************************************/
    function clickToggle(toggle) {
        const { index, level } = toggle.dataset
        const list = loopify(lists).find(l => l.dataset.index === index)
        const parentInner = toggle.parentElement

        loopify(inners).forEach(i => i.classList.remove('is-active', 'is-open'))
        loopify(lists).forEach(l => l.classList.remove('is-open'))

        parentInner.classList.add('is-active', 'is-open')
        list.classList.add('is-open')

        if (parseInt(level) === 2) {
            const grandParentItem = toggle.closest('.js-item[data-level="1"]')
            grandParentItem.querySelector('.js-inner').classList.add('is-open')
            grandParentItem.querySelector('.js-list').classList.add('is-open')
        }
    }

    function init() {
        decideShow()
        setCurrentLink()
    }

    function decideShow() {
        const currentGender = localStorage.getItem('spreeglee_gender') || 'unisex'
        if (currentGender === gender) {
            node.classList.add('is-active')
        }
    }

    function setCurrentLink() {
        const currentLink = loopify(links).find(l => l.href === location.origin + location.pathname)

        if (currentLink) {
            const parentInner = currentLink.closest('.js-inner')
            const { level } = parentInner.dataset

            parentInner.classList.add('is-active', 'is-open')

            if (parseInt(level) === 1 || parseInt(level) === 2) {
                const list = parentInner.parentElement.querySelector('.js-list')
                if (list) list.classList.add('is-open')
            }
            
            if (parseInt(level) === 2) {
                const parentList = currentLink.closest('.js-list[data-level="1"]')
                parentList.classList.add('is-open')
                
                const grandParentInner = parentList.parentElement.querySelector('.js-inner')
                grandParentInner.classList.add('is-open')
            }
            
            if (parseInt(level) === 3) {
                const parentList = currentLink.closest('.js-list[data-level="2"]')
                parentList.classList.add('is-open')

                const grandParentList = currentLink.closest('.js-list[data-level="1"]')
                grandParentList.classList.add('is-open')
                
                const grandParentInner = parentList.parentElement.querySelector('.js-inner')
                grandParentInner.classList.add('is-open')

                const greatGrandParentInner = grandParentList.parentElement.querySelector('.js-inner')
                greatGrandParentInner.classList.add('is-open')
            }
        }
    }
})